import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { getMainTokenContract } from 'modules/api/contracts/getMainTokenContract';
import { getPublicClient } from 'modules/api/getPublicClient';
import { convertFromWei } from 'modules/api/utils';

export async function getMainTokenBalance(
  accountAddress: Address,
): Promise<BigNumber> {
  const contract = getMainTokenContract(getPublicClient());

  const balanceWei: bigint = await contract.read.balanceOf([accountAddress]);

  return convertFromWei(balanceWei);
}
